module.exports = __webpack_public_path__ + "media/images/serviette-26a133991653335868ad9fe3e3a05e7a.svg";